document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', () => {
    return {
      itemsRoot: null,
      locked: null,
      async _morphItems(e) {
        if (!e.detail.response.sections) return;
        Alpine.morph(
          this.itemsRoot,
          querySelectorInHTMLString(
            '[data-cart-items]',
            e.detail.response.sections['cart-items']
          ).outerHTML
        );

        // const userCountry = localStorage.getItem("ELKAD-userShippingCountry") ? localStorage.getItem("ELKAD-userShippingCountry") : Shopify.Country;

        // if (userCountry == 'CA') {
        //   this.$root.querySelectorAll("[data-cart-item-id='47498715824420']").forEach((item) => {
        //     const currentQuantity = item.querySelector("input[type='number']").value;

        //     if (currentQuantity >= 3) {
        //       item.querySelector("button[aria-label='+']").disabled = true;
        //       item.querySelector("button[aria-label='+']").style.opacity = 0.5;
        //     } else {
        //       item.querySelector("button[aria-label='+']").disabled = false;
        //       item.querySelector("button[aria-label='+']").style.opacity = 1;
        //     }
        //   });
        // }
      },
      init() {
        this.itemsRoot = this.$root;

        window.addEventListener('shapes:modalcart:cartqtychange', (e) => {
          this.$nextTick(() => {
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const liveRegionText = parseDOMFromString(
            e.detail.response.sections['cart-live-region']
          ).firstElementChild.textContent;

          const cartStatus = document.getElementById('cart-live-region-text');

          cartStatus.textContent = liveRegionText;

          cartStatus.setAttribute('aria-hidden', false);

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }
        });

        // const userCountry = localStorage.getItem("ELKAD-userShippingCountry") ? localStorage.getItem("ELKAD-userShippingCountry") : Shopify.Country;

        // if (userCountry == 'CA') {
        //   this.$root.querySelectorAll("[data-cart-item-id='47498715824420']").forEach((item) => {
        //     const currentQuantity = item.querySelector("input[type='number']").value;

        //     if (currentQuantity >= 3) {
        //       item.querySelector("button[aria-label='+']").disabled = true;
        //       item.querySelector("button[aria-label='+']").style.opacity = 0.5;
        //     } else {
        //       item.querySelector("button[aria-label='+']").disabled = false;
        //       item.querySelector("button[aria-label='+']").style.opacity = 1;
        //     }
        //   });
        // }
      },
      async itemQuantityChange(key, value) {
        if (this.locked) return;

        const lineItemEl = this.$el.closest('li[data-cart-item-key]');
        const productId = lineItemEl.getAttribute('data-product-id');
        const id = lineItemEl.getAttribute('data-cart-item-key'),
          quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10);

        if (Shopify.country == 'CA' && quantity > 3 && id.startsWith("47498715824420")) {
          this.$el.value = 3;
          return;
        }

        if (quantity > 1 && productId == "8884524220708") {
          this.$el.value = 1;
          return;
        }
        const lastValue = parseInt(this.$el.dataset.lastValue, 10);

        if (quantity !== lastValue) {
          lineItemEl.classList.add('opacity-50', 'cursor-progress');

          const currentCount = Alpine.raw(Alpine.store('cart_count').count);

          // this.locked = lineItemEl;

          const callback = (data) => {
            if (data.status === 422 || data.status === 400 || data.status == "bad_request") {
              const errorEl = lineItemEl.querySelector(
                '[data-cart-quantity-error]'
              );

              errorEl.textContent = "An error occured, please refresh your page.";

              errorEl.style.display = '';
              lineItemEl.classList.remove('opacity-50', 'cursor-progress');

              // this.$el.value = lastValue;
            }

            // this.locked = null;
            this.$el.dataset.lastValue = lastValue;
            // this.$el.value = lastValue;
          }

          const data = {
            id,
            quantity
          };

          window.liquidAjaxCart.change(data, {lastCallback: (requestState) => {callback(requestState)}});
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      async _adjustQty(el, operation) {
        const inputEl = el
          .closest('li[key]')
          .querySelector('input[type="number"]');

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);
        const id = el.closest('li').getAttribute('data-cart-item-key');

        if (operation == 'increment' && Shopify.country == 'CA' && lastValue + 1 > 3 && id.startsWith("47498715824420")) return;

        let newValue;

        if (operation == 'increment') {
          newValue = lastValue + 1;
        }

        if (operation == 'decrement') {
          if (lastValue > 1) {
            newValue = lastValue - 1;
          } else {
            // newValue initialy set to 1 but changed to 0 to remove product when decrement to 0
            newValue = 0;
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;

        // this.$nextTick(() => {
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        // });
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this._adjustQty(this.$el, 'remove');
      },
    };
  });
});
